import { api } from "./api";

export const cfaListApi = (params) => {
  return api.get(`/manufacturer/cfa/list`, { params });
};
export const cfaCreateApi = (params) => {
  return api.post(`/manufacturer/cfa/create`, JSON.stringify(params));
};
export const cfaEditApi = (params) => {
  return api.post(`/manufacturer/cfa/edit`, JSON.stringify(params));
};
export const cfaViewApi = (params) => {
  return api.get(`/manufacturer/cfa/view`, { params: params });
};
export const cfaVersionListApi = (params) => {
  return api.get(`/manufacturer/cfa/version-list`, { params });
};
export const cfaVersionDetailApi = (params) => {
  return api.get(`/manufacturer/cfa/version-view`, { params: params });
};
export const cfaHeadQuaterListApi = (params) => {
  return api.get(`/manufacturer/cfa/head-quarters-list`);
};
export const cfaDistributorListApi = (params) => {
  return api.get(`/manufacturer/cfa/distributors-list`);
};

export const cfaEnableDisabletApi = (params) => {
  return api.post(`/manufacturer/cfa/enable-disable`, params);
};
export const cfaSendMailApi = (params) => {
  return api.post(`/manufacturer/cfa/send-mail`, params);
};
export const cfaDeleteApi = (params) => {
  return api.delete(`/manufacturer/cfa/delete`, { data: params });
};
